export function orderDatesWarningMessages(deliveryDate) {
    let messages = [];

    if (deliveryDate && deliveryDate.authorizations) {

        for (const authorization of deliveryDate.authorizations) {
            if (authorization.warnLevel === 'restricted') {
                messages.push(authorization.reason + ".");
            }
        }
    }

    return messages;
}

export function orderDatesDangerMessages(deliveryDate, endPreparationDate) {
    let messages = [];

    if (deliveryDate && deliveryDate.authorizations) {
        for (const authorization of deliveryDate.authorizations) {
            if (authorization.warnLevel === 'forbidden') {
                messages.push(authorization.reason + ".");
            }
        }
    }

    if (endPreparationDate) {
        if(endPreparationDate.type === 'forced') {
            messages.push("Vous tentez de forcer une date de fin de préparation." );
        }
    }

    return messages;
}

export function warningZoneDisplayed() {
    return this.warningMessages.length > 0;
}

export function dangerZoneDisplayed() {
    return this.dangerMessages.length > 0;
}
